<template>
    <el-row class="mx-2 mt-4">
        <el-tooltip class="item" effect="dark" placement="top">
            <div slot="content">
                <strong>Authentication</strong>
                <br>
                <small>This will redirect you to {{ integrationNameWithCasing }} for authentication.</small>
            </div>
            <el-button size="btn-text" @click="oauth()">
                <span>Authenticate</span>
            </el-button>
        </el-tooltip>
    </el-row>
</template>
<script>
export default {
    data() {
        return {}
    },
    props: {
        integrationNameWithCasing: {
            type: String,
            required: true
        },
        oauth: {
            type: Function,
            required: true
        },
    }
}
</script>
